module.exports = __webpack_public_path__ + "static/media/menu-opened.ec8b2c27.svg";